import { getAuthToken } from "../security/AuthLogin";

const BASE_URL = `${window.location.protocol}//${window.location.hostname}`;
const API_URL = `${BASE_URL}/api`;

// Obtener todas las adjudicaciones con parámetros de consulta
export const fetchAdjudicaciones = async (params: {
  [key: string]: string | number | string[];
}) => {
  const token = getAuthToken();

  if (!token) {
    window.location.href = "/login";
    throw new Error("Token no encontrado. El usuario no está autenticado.");
  }

  const queryParams = new URLSearchParams();

  for (const key in params) {
    const value = params[key];
    if (Array.isArray(value)) {
      value.forEach((val) => queryParams.append(key, val));
    } else {
      queryParams.append(key, value.toString());
    }
  }

  const response = await fetch(
    `${API_URL}/adjudicaciones?${queryParams.toString()}`,
    {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  if (!response.ok) {
    if (response.status === 403 || response.status === 401) {
      localStorage.removeItem("authToken");
      window.location.href = "/login";
      throw new Error("Token expirado o inválido");
    }
    const errorText = await response.text();
    throw new Error(`Error al obtener las adjudicaciones: ${errorText}`);
  }

  const data = await response.json();
  return data;
};

// Obtener una adjudicación específica por ID
export const fetchAdjudicacionById = async (id: string) => {
  const token = getAuthToken();

  if (!token) {
    window.location.href = "/login";
    throw new Error("Token no encontrado. El usuario no está autenticado.");
  }

  const response = await fetch(`${API_URL}/adjudicaciones/${id}`, {
    method: "GET",
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) {
    if (response.status === 404) {
      // Armamos Error con status=404
      const notFoundError: any = new Error("Adjudicación no encontrada");
      notFoundError.status = 404;
      throw notFoundError;
    } else {
      const errorText = await response.text();
      throw new Error(
        errorText || "Error al obtener los datos de la adjudicación"
      );
    }
  }

  return response.json();
};

// Actualizar una adjudicación específica por ID
export const updateAdjudicacion = async (id: string, updates: any) => {
  const token = getAuthToken();

  if (!token) {
    window.location.href = "/login";
    throw new Error("Token no encontrado. El usuario no está autenticado.");
  }

  const response = await fetch(`${API_URL}/adjudicaciones/${id}`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(updates),
  });

  if (!response.ok) {
    throw new Error("Error al actualizar la adjudicación");
  }

  return response.json();
};

// Eliminar una adjudicación específica por ID
export const deleteAdjudicacion = async (id: string) => {
  const token = getAuthToken();

  if (!token) {
    window.location.href = "/login";
    throw new Error("Token no encontrado. El usuario no está autenticado.");
  }

  const response = await fetch(`${API_URL}/adjudicaciones/${id}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) {
    throw new Error("Error al eliminar la adjudicación");
  }

  return response.json();
};

// Crear una nueva adjudicación
export const createAdjudicacion = async (newAdjudicacion: any) => {
  const token = getAuthToken();

  if (!token) {
    window.location.href = "/login";
    throw new Error("Token no encontrado. El usuario no está autenticado.");
  }

  const response = await fetch(`${API_URL}/adjudicaciones/crear`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(newAdjudicacion),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Error al crear la adjudicación: ${errorText}`);
  }

  return response.json();
};
